<template>
  <client-only>
    <button
      v-show="scrollTop"
      class="btn btn-success text-center btn-scroll-top rounded-full fixed right-8 bottom-10 z-100"
      @click="scrollToTop"
    >
      <font-awesome-icon icon="chevron-up" size="lg" />
    </button>
  </client-only>
</template>

<script>
export default {
  name: 'ScrollToTop',
  data: () => ({
    scrollTop: false
  }),
  created () {
    this.scrollToTopActive()
  },
  methods: {
    scrollToTop () {
      this.$scrollToTop()
    },
    scrollToTopActive () {
      if (process.client) {
        const self = this
        window.addEventListener('scroll', function () {
          const scrollPos = window.scrollY
          self.scrollTop = scrollPos > 350
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.btn-scroll-top {
  width: 50px;
  height: 50px;
  outline: none !important;
}
</style>
